import { Paper, TableContainer, Table, TableCell, TableRow, TableHead, TableBody, Rating } from "@mui/material";
import Tip from "../../../Tools/Tip";

export default function Courses({items, onDelete}){

    const handleDelete = id => {

        const ok = window.confirm("Êtes vous sûr de vouloir retirer cette formation du compte du formateur ?");

        return ok ? onDelete(id) : null;
    }

    return items && <TableContainer component={Paper}>

        <Table>

            <TableHead>
                <TableRow>
                    <TableCell><b>Nom</b></TableCell>
                    <TableCell><b>Inscriptions</b></TableCell>
                    <TableCell><b>CA</b></TableCell>
                    <TableCell><b>Note</b></TableCell>
                    <TableCell><b>Avis</b></TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {items.map(i => 
                    <TableRow key={i.id} data-id={i.id}>
                        <TableCell>{i.title}</TableCell>
                        <TableCell>{(i.enrollments?.count || 0).toLocaleString()}</TableCell>
                        <TableCell>{(i.enrollments?.amount || 0).toLocaleString()}<small>€</small></TableCell>
                        <TableCell>
                            {i.reviews && <>
                                <Rating value={i.reviews.average} precision={0.5} readOnly/> 
                            </>}
                        </TableCell>
                        <TableCell>
                            {i.reviews && <>
                                {i.reviews.average.toFixed(1)} <small>({i.reviews.count})</small>
                            </>}
                        </TableCell>
                        <TableCell>
                            <Tip type='delete' onClick={() => handleDelete(i.id)} />
                        </TableCell>
                    </TableRow>    
                )}
            </TableBody>

        </Table>

    </TableContainer>
}


